module.exports = __webpack_public_path__ + "static/media/bodal2.13087e46.png";